import React from 'react';
import './index.scss';
import App from './App';
import { render } from "react-dom";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import NavigationLinks from './config/NavigationLinks';
import NotFound from './pages/NotFound';
import V1GameRedirector from './components/V1GameRedirector';
import GameData from "./mobx/GameData";

let children = [], currentKey = 0;

class NavigationRedirectComponent extends React.Component {
  
  render() {
    if ((this.props.linkGroup.filter && !this.props.linkGroup.filter(null, GameData.currentGame))) {
      return <Navigate replace to="/home" />
    }
    return <>{React.cloneElement(this.props.element)}</>
  }
}

NavigationLinks.forEach(linkGroup => {
  currentKey++;
  if (linkGroup.divider) { return; }
  let thisChildren = [];
  linkGroup.elements.forEach(link => {
    currentKey++;
    thisChildren.push(
      <Route path={link.href} element={<NavigationRedirectComponent linkGroup={linkGroup} element={link.element} />} key={'nav-route-' + currentKey} />)
  })

  children.push(
    <Route path={linkGroup.root} key={'nav-route-' + currentKey}>
      {thisChildren}
    </Route>
  );
})

render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Navigate replace to="/home" />} />
        <Route path="/" element={<App />}>
          {children}
          <Route path="/games/*" element={<V1GameRedirector />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
